
import React, { useState, useEffect } from "react"
import { observer } from "mobx-react-lite"
import { useTheme } from '~/ui/styled'
import useNavigation from "~hooks/useNavigation"
import { rules } from "~utils/validator"
import { PopupOptionListModal } from "~modals/popup-option-list-modal"
import { ButtonAccordion, TextAccordion, InputTextAccordion } from "~components/accordion"
import { useStores } from "~models"
import { isEmpty, validate } from "~utils"
import styled from '~/ui/styled'
import { AccusationNewData, Event, EventNames, FLAG_ACK } from "~proto"
import { AccusationProps } from "./types"

const Container = styled.View`
  margin-bottom: ${({ theme }) => theme.space.md};
`

const BottomGap = styled.View`
  margin-bottom: ${({ theme }) => theme.space.sm};
`

const Accusation: React.FC<AccusationProps> = ({ userId }) => {
  const theme = useTheme()
  const navigation = useNavigation()
  const { eventStore } = useStores()
  const [isAccusationTypePickerVisible, setIsAccusationTypePickerVisible] = useState(false)
  const [accusationType, setAccusationType] = useState(null)
  const [accusationDescription, setAccusationDescription] = useState("")
  const [formErr, setFormErr] = useState(false)

  useEffect(() => {
    setFormErr(
      !isEmpty(
        validate(
          {
            accusationType: rules.accusationType,
          },
          { accusationType },
        ),
      ),
    )
  }, [accusationType])

  const handleAccusation = () => {
    const evt = new Event<AccusationNewData>(EventNames.ACCUSATION_CREATE, {
      accused_id: userId,
      type: accusationType,
      description: accusationDescription,
    })
    eventStore.publish(evt, { flags: FLAG_ACK })
    navigation.navigate("AccusationSuccess")
  }

  const options = [
    {
      id: 1,
      visible: true,
      text: "存在欺诈骗钱行为",
      value: 1,
      onClick: () => {
        setAccusationType(1)
        setIsAccusationTypePickerVisible(false)
      },
    },
    {
      id: 2,
      visible: true,
      text: "发布色情/违法等不良信息",
      value: 2,
      onClick: () => {
        setAccusationType(2)
        setIsAccusationTypePickerVisible(false)
      },
    },
    {
      id: 3,
      visible: true,
      text: "其他违规行为",
      value: 0,
      onClick: () => {
        setAccusationType(0)
        setIsAccusationTypePickerVisible(false)
      },
    },
  ]

  const accusationTypeText = options.find(({ value }) => value === accusationType)?.text || "请选择"

  return (
    <>
      <Container>
        <TextAccordion
          accordionProps={{
            onClick: () => setIsAccusationTypePickerVisible(true),
            labelColor: theme.colors.primaryText,
            label: "举报理由(必填)",
            hasRightIcon: true,
          }}
          textProps={{
            text: accusationTypeText,
          }}
          onTextPress={() => setIsAccusationTypePickerVisible(true)}
        />
        <InputTextAccordion
          accordionProps={{
            labelColor: theme.colors.primaryText,
            label: "证据描述",
          }}
          inputTextProps={{
            placeholder: "请输入证据描述",
            defaultValue: accusationDescription,
            onChangeText: setAccusationDescription,
            style: {
              height: 150,
            },
            textAlignVertical: "top",
            multiline: true,
            maxLength: 240,
          }}
        />
      </Container>
      <BottomGap />
      <ButtonAccordion
        buttonTextProps={{
          text: "举报提交",
          color: theme.colors.primary,
          disabled: formErr,
          onClick: handleAccusation,
        }}
        accordionProps={{ onClick: handleAccusation, disabled: formErr }}
      />
      <PopupOptionListModal
        visible={isAccusationTypePickerVisible}
        setVisible={setIsAccusationTypePickerVisible}
        options={options}
       />
    </>
  )
}

export default observer(Accusation)
